export const privacyPolicy =
  "https://rantt.notion.site/Rantt-Terms-of-Use-Privacy-Policy-d112ab7ec654409396f18737d1d229fd#a830eb83e1cf402182f940ceedab3d51"

export const TermsOfService =
  "https://rantt.notion.site/Rantt-Terms-of-Use-Privacy-Policy-d112ab7ec654409396f18737d1d229fd"
